    document.addEventListener('DOMContentLoaded', () => {
        let slider = tns({
            container: '.gallery',
            items: 1,
            mode: 'carousel',
            loop: false,
            autoplay: false,
            controls: '.controls',
            prevButton: '.prevButton',
            nextButton: '.nextButton',
            slideBy: 'page',
            nav: true,
            navPosition: 'bottom'
        });

        let addToCartButtons = document.querySelectorAll('[data-testid="pdp-continue"]'),
            bagCountInput = document.getElementById('bag-count'),
            decreaseButton = bagCountInput.previousElementSibling,
            increaseButton = bagCountInput.nextElementSibling;

        if(addToCartButtons.length > 0) {
            addToCartButtons.forEach((addToCartButton) => {
                addToCartButton.addEventListener('click', async function(event) {
                    event.preventDefault();
                    let form = document.querySelector('form[action="/cart/add"]'),
                    quantity = parseInt(bagCountInput.value),
                    formData = new FormData(form);
                    self = event.currentTarget,
                    headers = {
                        'Accept': 'application/json'
                    };

                    console.log(formData);

                    formData.set('quantity', quantity);
                    self.classList.add('disabled');
                    self.innerHTML = `<span class="loader"></span>`;

                    if(document.querySelector('button.added')) {
                        let variantId = document.querySelector('input[name="id"]:checked').value;

                        formData = {
                            items: [
                                {
                                    id: variantId,
                                    quantity: quantity
                                }
                            ]
                        };

                        headers = {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        };

                        document.querySelectorAll('button.added').forEach(button => {
                            let productId = button.id;
                            formData.items.push({
                                id: productId,
                                quantity: 1
                            });
                        });

                        formData = JSON.stringify(formData);
                    }
                    
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        body: formData,
                        headers
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log('Item added to cart:', data);
                        self.innerHTML = 'Continue';
                        self.classList.remove('disabled');
                        window.location.href = '/checkout';
                    })
                    .catch(error => {
                        console.error('Error adding to cart:', error);
                    });
                });
            })
        }

        decreaseButton.addEventListener('click', function(e) {
            e.preventDefault();
            let currentValue = parseInt(bagCountInput.value);

            if (currentValue > 1) {
                bagCountInput.value = currentValue - 1;
                document.querySelector('.perBag').innerText = ``;
            }
            let checkedVariant = document.querySelector('input[name="id"]:checked'),
            variantPrice = checkedVariant.getAttribute('price'),
            total = variantPrice * parseInt(bagCountInput.value);
            document.querySelector('.subtotal').innerText = formatMoney(total);
        });

        increaseButton.addEventListener('click', function(e) {
            e.preventDefault();
            let currentValue = parseInt(bagCountInput.value);
            bagCountInput.value = currentValue + 1,
            checkedVariant = document.querySelector('input[name="id"]:checked'),
            variantPrice = checkedVariant.getAttribute('price'),
            total = variantPrice * parseInt(bagCountInput.value);
            if(bagCountInput.value > 1) {
                document.querySelector('.subtotal').innerText = formatMoney(total);
                document.querySelector('.perBag').innerText = `por producto`;
            }
        });

        const formatMoney = (total) => {
            let currencySymbol = document.getElementById('currency').value;
            return `${currencySymbol}` + (total / 100).toFixed(2).replace('.', ',');
        };

        /** * related product add to bag before go to checkout **/
        const relatedAddToOrderButtons = document.querySelectorAll('.related-grid-products button');
        if(relatedAddToOrderButtons.length > 0) {
            relatedAddToOrderButtons.forEach((button) => {
                button.addEventListener('click', function(e) {
                    e.preventDefault();

                    e.currentTarget.classList.toggle('added');
                    e.currentTarget.innerText = e.currentTarget.classList.contains('added') ? 'ELIMINAR DE LA ORDEN' : 'AÑADIR A ORDEN';

                    setTimeout(() => {
                        if(document.querySelectorAll('.related-grid-products button.added').length > 0) {
                            document.querySelector('button[data-id="accessories-continue"]').removeAttribute('disabled')
                            document.querySelector('button[data-id="accessories-continue"]').classList.remove('cursor-not-allowed');
                            document.querySelector('button[data-id="accessories-continue"]').classList.remove('opacity-25');
                        } else {
                            document.querySelector('button[data-id="accessories-continue"]').setAttribute('disabled', 'disabled');
                            document.querySelector('button[data-id="accessories-continue"]').classList.add('cursor-not-allowed');
                            document.querySelector('button[data-id="accessories-continue"]').classList.add('opacity-25');
                        }
                    }, 200);
                });
            });
        }

    });